'use client';

import React from 'react';
import { ContentfulTextEditorPropTypes } from './ContentfulTextEditor.types';
const ContentfulTextEditor: React.FC<ContentfulTextEditorPropTypes> = ({
  className = '',
  children
}) => {
  React.useEffect(() => {
    const scrollContainers = document.querySelectorAll('.scroll-indicator');
    const fadeGradientsRight = document.querySelectorAll('.gradient-fade');
    const fadeGradientsLeft = document.querySelectorAll('.gradient-fade-left');
    scrollContainers.forEach((scrollContainer, index) => {
      const fadeGradientRight = fadeGradientsRight[index] as HTMLElement;
      const fadeGradientLeft = fadeGradientsLeft[index] as HTMLElement;
      if (scrollContainer && fadeGradientRight && fadeGradientLeft) {
        // Initially, only show the right gradient
        fadeGradientRight.style.display = 'block';
        fadeGradientLeft.style.display = 'none';
        const checkScroll = () => {
          const scrollWidth = scrollContainer.scrollWidth;
          const clientWidth = scrollContainer.clientWidth;
          const scrollLeft = scrollContainer.scrollLeft;

          // Check if the user is at the start of the scrollable area
          const isAtStart = scrollLeft === 0;

          // Check if the user is at the end of the scrollable area
          const isAtEnd = scrollLeft + clientWidth >= scrollWidth;

          // Right gradient is visible unless at the end
          fadeGradientRight.style.display = isAtEnd ? 'none' : 'block';

          // Left gradient is visible when not at the start
          fadeGradientLeft.style.display = !isAtStart ? 'block' : 'none';
        };
        scrollContainer.addEventListener('scroll', checkScroll);

        // Cleanup event listener on component unmount
        return () => {
          scrollContainer.removeEventListener('scroll', checkScroll);
        };
      }
    });
  }, []);
  React.useEffect(() => {
    // Function to add playsinline to autoplay videos
    const addPlaysinlineToAutoplayVideos = () => {
      const videoElements = document.querySelectorAll('video[autoplay]');
      videoElements.forEach(video => {
        video.setAttribute('playsinline', '');
      });
    };
    addPlaysinlineToAutoplayVideos();
  }, [children]);
  return <div className={className} data-sentry-component="ContentfulTextEditor" data-sentry-source-file="ContentfulTextEditor.tsx">{children}</div>;
};
export default ContentfulTextEditor;